import React, { useState, useEffect } from "react";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import { FaFileCsv, FaDownload } from "react-icons/fa";

const DownloadDeliveryLogs = () => {
	const [files, setFiles] = useState([]);
	const [loading, setLoading] = useState(true);

	const getFiles = async () => {
		try {
			const { data } = await axios.get(
				"https://ecobank.approot.ng/dashboard/list.php"
			);
			setFiles(data || []);
		} catch (e) {
			console.error("Error fetching file list:", e);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getFiles();
	}, []);

	const handleDownload = (filename) => {
		const url = `https://ecobank.approot.ng/dashboard/downloadcsv.php?file=${filename}`;
		window.location.href = url;
	};

	const formatFilename = (filename) => {
		// Optional: remove timestamp or .csv if needed
		return filename.replace(".csv", "").replace(/_/g, " ");
	};

	if (loading) {
		return (
			<div className='flex justify-center items-center py-16'>
				<CircularProgress size={40} thickness={5} />
			</div>
		);
	}

	return (
		<div className='max-w-4xl mx-auto p-6 bg-gradient-to-br from-white via-gray-50 to-gray-100 rounded-xl shadow-lg'>
			<h2 className='text-3xl font-bold mb-6 text-center text-blue-800'>
				📦 Delivery Log Downloads
			</h2>

			{files.length === 0 ? (
				<p className='text-gray-600 text-center text-lg'>
					No delivery logs found.
				</p>
			) : (
				<ul className='divide-y divide-gray-300'>
					{files.map((file, index) => (
						<li
							key={index}
							className='flex items-center justify-between py-4 px-3 hover:bg-blue-50 rounded-md transition duration-150 ease-in-out group'
						>
							<div className='flex items-center gap-3'>
								<FaFileCsv className='text-green-600 text-xl group-hover:scale-105 transition' />
								<span className='text-base font-medium text-gray-800 group-hover:text-blue-700'>
									{formatFilename(file)}
								</span>
							</div>
							<button
								onClick={() => handleDownload(file)}
								className='bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md flex items-center gap-2 shadow-sm transition transform hover:scale-105'
							>
								<FaDownload className='text-sm' />
								<span className='text-sm font-medium'>Download</span>
							</button>
						</li>
					))}
				</ul>
			)}
		</div>
	);
};

export default DownloadDeliveryLogs;
